import $ from 'jquery'

// Runs the jQuery-side contents-changed callbacks on nodes just added to the page. Kept out of
// Stimulus controllers, which the UI ratchet holds to no new jQuery.
export function notifyDomChanged(nodes) {
  $(nodes).changed?.()
}
